import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-petition-groups-find',
		path: '/admin/p/:slug/find_or_create_petition_group',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_petition_groups_find" */ './index'), {
			exportName: 'AdminPetitionGroupsFind',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['support', 'campaigns'],
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
